import { InfoDetailsProps } from 'components/info-component/info-component';
import { TableColumnProps } from 'components/table/table-component/table-component';

export const tableStructureWithoutOrg: TableColumnProps[] = [
  {
    id: 'name',
    title: 'Asset Name',
    withSort: true,
    position: 'left',
    withSearch: true,
  },
  {
    id: 'highest_severity',
    title: 'Risk Rating',
    withSort: true,
    position: 'left',
  },
  {
    id: 'vulnerabilities',
    title: 'Vuln. Counts',
    position: 'left',
  },

  {
    id: 'source',
    title: 'Source',
    withSort: true,
    position: 'left',
  },
  {
    id: 'status',
    title: 'Status',
    withSort: true,
    position: 'left',
  },
  {
    id: 'owners',
    title: 'Inferred Owner',
    withSort: true,
    position: 'left',
  },
  {
    id: 'last_activity',
    title: 'Last Event',
    withSort: true,
    position: 'left',
    isDate: true,
  },
  {
    id: 'is_production',
    title: 'CI/CD Component',
    withSort: true,
    position: 'left',
  },
];

export const tableStructureWithOrg: TableColumnProps[] = [
  {
    id: 'name',
    title: 'Asset Name',
    withSort: true,
    position: 'left',
    withSearch: true,
  },
  {
    id: 'highest_severity',
    title: 'Risk Rating',
    withSort: true,
    position: 'left',
  },
  {
    id: 'vulnerabilities',
    title: 'No of. Vulnerabilities',
    position: 'left',
    withSort: true,
    noFilters: true,
  },
  {
    id: 'ossf_score',
    title: 'OSSF Score',
  },
  {
    id: 'source',
    title: 'Source',
    withSort: true,
    position: 'left',
  },
  {
    id: 'visibility',
    title: 'Visibility',
    position: 'left',
    withSort: true,
  },
  {
    id: 'org',
    title: 'Organization',
    withSort: true,
    position: 'left',
    withSearch: true,
    noFilters: true,
  },
  {
    id: 'status',
    title: 'Status',
    withSort: true,
    position: 'left',
  },
  {
    id: 'last_activity',
    title: 'Last Event',
    withSort: true,
    position: 'left',
    isDate: true,
    noFilters: true,
  },
  {
    id: 'is_production',
    title: 'CI/CD Component',
    withSort: true,
    position: 'left',
    noFilters: true,
  },
];

export const assetInfoStructure: InfoDetailsProps[] = [
  {
    id: 'name',
    title: 'Asset',
  },
  {
    id: 'highest_severity',
    title: 'Risk Rating',
  },
  {
    id: 'source',
    title: 'Source',
  },
  {
    id: 'visibility',
    title: 'Visibility',
  },

  {
    id: 'vulnerabilities',
    title: 'No. of Vulnerabilities',
  },

  {
    id: 'org',
    title: 'Organization',
  },
  {
    id: 'last_activity',
    title: 'Last Event',
    isDate: true,
  },
  {
    id: 'first_commit',
    title: 'First Event',
    isDate: true,
  },
  {
    id: 'entity_graph',
    title: 'Graph',
  },
];

export const assetInfoStructureJFrog: InfoDetailsProps[] = [
  {
    id: 'name',
    title: 'Asset',
  },
  {
    id: 'source',
    title: 'Source',
  },
  {
    id: 'org',
    title: 'Organization',
  },
  {
    id: 'last_activity',
    title: 'Last Event',
    isDate: true,
  },
  {
    id: 'first_commit',
    title: 'First Event',
    isDate: true,
  },
];

export const cloudAssetInfoStructure: InfoDetailsProps[] = [
  {
    id: 'asset_name',
    title: 'Cloud Asset',
  },
  {
    id: 'cloud_type',
    title: 'Cloud Type',
  },
  {
    id: 'account_name',
    title: 'Account Name',
  },
  {
    id: 'region_name',
    title: 'Region Name',
  },
];

export const cloudAccountInfoStructure: InfoDetailsProps[] = [
  {
    id: 'account_name',
    title: 'Account Name',
  },
  {
    id: 'account',
    title: 'Account Id',
  },
  {
    id: 'total_users',
    title: 'Total Users',
  },
  {
    id: 'active_users',
    title: 'Active Users',
  },
];
